import { ElementType } from 'react';

interface Props {
  StyledLinkBox: ElementType;
  StyledLink: ElementType;
  StyledButton: ElementType;
}

export const PageLinks = ({ StyledLinkBox, StyledLink, StyledButton }: Props) => {
  return (
    <StyledLinkBox>
      <StyledLink
        to="https://www.guycarp.com/company/about/privacy-policy.html"
        target="_blank"
      >
        Privacy Notice
      </StyledLink>
      <StyledLink
        to="https://www.guycarp.com/company/about/cookie-notice.html"
        target="_blank"
      >
        Cookie Preferences
      </StyledLink>
      <StyledButton onClick={() => Osano.cm.showDrawer('osano-cm-dom-info-dialog-open')}>
        Manage Cookies
      </StyledButton>
    </StyledLinkBox>
  );
};
